// import { useSelector } from 'react-redux';
// import Loading from '../../reusableElementsComponents/Loading';
import mazharLogo from "../../../assets/images/logos/apex_analytics_green_logo.svg";


function MobileAuthHeader({title, secondaryTitle, subTitle, illustration, logo}) {
    // const data = useSelector( state => state.contentfulData.all['Auth mobile decoration']);

    return (
        <div className="col-12 d-lg-none auth-mobile-header p-0">

            <div className="title-wrapper">
                <h1 className="title l semi-bold">{title}</h1>

                {logo === true ? <img className="logo" src={mazharLogo} alt="Apex Analytics" /> : 'MazHr' }

                <h1 className="title semi-bold">{secondaryTitle}</h1>

                {illustration ? <img src={illustration} alt="Apex Analytics" /> : ''}

                <p className="sub-title">{subTitle}</p>
            </div>
        </div>
    )
}

export default MobileAuthHeader;
